import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../services/AuthService';
import userImage from '../assets/admin/img/user.png';
import { useLocation } from "react-router-dom";

const Navbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();

  // Logout Function
  const handleLogout = () => {
    AuthService.logout();
    navigate('/');
  };
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));

  return (
    <nav className="navbar navbar-expand bg-light navbar-light sticky-top px-4 py-0">
      <a href="/" className="navbar-brand d-flex d-lg-none me-4">
        <h2 className="text-primary mb-0">
          <i className="fa fa-hashtag"></i>
        </h2>
      </a>

      {/* Sidebar Toggle Button */}
      <button className="sidebar-toggler flex-shrink-0" onClick={toggleSidebar}>
        <i className="fa fa-bars"></i>
      </button>

      <form className="d-none d-md-flex ms-4">
        <input className="form-control border-0" type="search" placeholder="Search" />
      </form>

      <div className="navbar-nav align-items-center ms-auto">
        <div className="nav-item dropdown">
          <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
            <img
              className="rounded-circle me-lg-2"
              src={userImage}
              alt="User"
              style={{ width: '40px', height: '40px' }}
            />
            <span className="d-none d-lg-inline-flex">{`${user.name}`}</span>
          </a>
          <div className="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0">
            <a href="#" className="dropdown-item">My Profile</a>
            {/* <a href="#" className="dropdown-item">Settings</a> */}
            <a href="#" className="dropdown-item" onClick={handleLogout}>
              Log Out
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
